<template>
  <div>
    <b-form-checkbox :checked="checkboxLocationGermany" @change="onLocationGermanyToggle" size="sm" switch :disabled="isLocationFromDropdown">
      {{ translations[15918] }}
      (<span v-if="!loadingLocationCount">{{ localeString(employmentCount.location_germany) }}</span
      ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
    </b-form-checkbox>
    <b-form-checkbox :checked="checkboxLocationNetherlands" @change="onLocationNetherlandsToggle" size="sm" switch :disabled="isLocationFromDropdown">
      {{ translations[15919] }}
      (<span v-if="!loadingLocationCount">{{ localeString(employmentCount.location_netherlands) }}</span
      ><b-spinner v-else variant="secondary" small type="grow" label="Load"></b-spinner>)
    </b-form-checkbox>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { ProfessionModule } from '@/store/modules/profession';
import { ICountType } from '@/types/ProfessionType';

@Component
export default class LocationCountryFilter extends Vue {
  @Prop({ default: false }) loadingLocationCount!: boolean;

  get translations() {
    return AppModule.translation;
  }

  get employmentCount(): ICountType {
    return ProfessionModule.employmentCount;
  }

  get isLocationFromDropdown() {
    const id = ProfessionModule.jobSearch.location_id;
    if (!id) return false;
    return +id !== 1206 && +id !== 1227;
  }

  get checkboxLocationGermany() {
    if (this.isLocationFromDropdown) return true;
    const lid = ProfessionModule.jobSearch.location_id;
    return lid == null || lid === '' || +lid === 1206;
  }

  get checkboxLocationNetherlands() {
    if (this.isLocationFromDropdown) return true;
    const lid = ProfessionModule.jobSearch.location_id;
    return lid == null || lid === '' || +lid === 1227;
  }

  onLocationGermanyToggle() {
    if (this.isLocationFromDropdown) return;
    const currentlyOn = this.checkboxLocationGermany;
    const newLocation = currentlyOn ? { id: 1227, name: this.translations[15919] } : null;
    ProfessionModule.SetSearchJobLocation(newLocation);
    ProfessionModule.SetSearchJobLocationTitle(newLocation);
    ProfessionModule.SetSearch({ obj: 'location_id', value: newLocation?.id ?? null });
    this.$nextTick(() => this.$emit('search'));
  }

  onLocationNetherlandsToggle() {
    if (this.isLocationFromDropdown) return;
    const currentlyOn = this.checkboxLocationNetherlands;
    const newLocation = currentlyOn ? { id: 1206, name: this.translations[15918] } : null;
    ProfessionModule.SetSearchJobLocation(newLocation);
    ProfessionModule.SetSearchJobLocationTitle(newLocation);
    ProfessionModule.SetSearch({ obj: 'location_id', value: newLocation?.id ?? null });
    this.$nextTick(() => this.$emit('search'));
  }

  localeString(payload: number) {
    return payload ? payload.toLocaleString() : 0;
  }
}
</script>
